export default "__VITE_ASSET__ehqpZTgY__"